module.exports = __webpack_public_path__ + "static/media/placeholder.85446ae3.svg";